import { render, staticRenderFns } from "./InvoiceItemFreeDimension.vue?vue&type=template&id=1407c79f&scoped=true&"
import script from "./InvoiceItemFreeDimension.vue?vue&type=script&lang=ts&"
export * from "./InvoiceItemFreeDimension.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceItemFreeDimension.vue?vue&type=style&index=0&id=1407c79f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1407c79f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDivider,VIcon,VRow,VSimpleTable,VTooltip})
